module.exports = __webpack_public_path__ + "static/media/ico_simulation_skin_red.6bfeaf96.png";